import {
  createStore as reduxCreateStore,
  applyMiddleware,
} from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createHistory from 'history/createBrowserHistory'
import promiseMiddleware from 'redux-promise-middleware'

import rootReducer from './reducers'

const history = createHistory()

const composeEnhancers = composeWithDevTools({
})

const enhancer = composeEnhancers(applyMiddleware(promiseMiddleware()))

const createStore = () => {
  const store = reduxCreateStore(
    rootReducer,
    enhancer
  )
  if(module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      //eslint-disable-next-line global-require
      const nextRootReducer = require('./reducers/index').default
      store.replaceReducer(nextRootReducer)
    })
  }
  return {
    store,
    history,
  }
}

export default createStore
